import React, { useRef } from 'react';
import HotspotMedia from '../../../common/ImageHotspot/HotspotMedia';
import PoweredBy from '../../../common/PoweredBy';
import CloseIcon from '../../../icons/CloseIcon';
import FlagIcon from '../../../icons/FlagIcon';
import { useDisplayWidgetContext } from '../../DisplayWidget/utils/context';
import { UseWindowDimensions } from '../../collage/utils';
import { IModal } from './interfaces';
import './modal.scss';
import ReadMoreReadLess from '../../../common/ReadMoreReadLess';
import { MdArrowForwardIos, MdArrowBackIos } from 'react-icons/md';
import { MdOutlineClose } from 'react-icons/md';
import { Swiper, SwiperSlide } from 'swiper/react';
import { GoMute, GoUnmute } from 'react-icons/go';
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from 'react-icons/md';
import { Navigation, Virtual } from 'swiper/modules';
import { getCurrentSymbol, PriceDisplay } from '../../../Helpers/Helpers';
import AnimatedModal from '../AnimatedModal';
import { FaShare, FaWhatsappSquare } from 'react-icons/fa';
import { BsCopy } from 'react-icons/bs';
import { FaSquareXTwitter } from 'react-icons/fa6';
import ProductsOverlay from '../components/ProductsOverlay';
import ShopifyModalRight from '../components/ShopifyModalRight';
import WocommerceModalRight from '../components/WocommerceModalRight';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/virtual';

const Modal: React.FC<IModal> = ({ isOpen, onClose }) => {
  const {
    data,
    layout,
    setReportModalData,
    onReportModalOpen,
    albumData,
    albumId,
    isShopify,
    shopifyData,
    quantity,
    setQuantity,
    guid,
    isWooCommerceSite,
    fetchNextPost,
    clickMutate,
  } = useDisplayWidgetContext();
  const isFlag = layout?.gallerySettings?.flagInappropriate;
  const [index, setIndex] = React.useState(null);
  const [isHotspot, setIsHotspot] = React.useState(false);
  const [showSharePopup, setShowSharePopup] = React.useState(false);

  React.useEffect(() => {
    setIsHotspot(false);
  }, [isOpen, index]);

  React.useEffect(() => {
    albumData?.map((row, id) => {
      if (row?.id == albumId) setIndex(id);
    });
  }, [albumId]);

  const products = albumData[index]?.products;
  React.useEffect(() => {
    return () => {
      setQuantity(1);
    };
  }, []);

  const updateHeight = () => {
    // const ht: number = window.visualViewport.height;
    // const short_video_container = document.querySelector('.short_video_container');
    // short_video_container['style']['height'] = ht + 'px';
  };

  const [isMuted, setIsMuted] = React.useState(true);

  const toggleMute = (index) => {
    const modalContainer = document.getElementById('idk_modal_container');
    const currentVideoElement = modalContainer.querySelector(`[id="slide_${index}"]`)?.getElementsByTagName('video');
    if (currentVideoElement.length > 0) {
      if (currentVideoElement[0].muted) {
        setIsMuted(false);
        currentVideoElement[0].muted = false;
      } else {
        setIsMuted(true);
        currentVideoElement[0].muted = true;
      }
    }
  };

  React.useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  const handleSlide = (slider: any) => {
    const modalContainer = document.getElementById('idk_modal_container');
    const currentVideoElement = modalContainer
      .querySelector(`[id="slide_${slider.activeIndex}"]`)
      ?.getElementsByTagName('video');
    const previousVideoElement = modalContainer
      .querySelector(`[id="slide_${slider.previousIndex}"]`)
      ?.getElementsByTagName('video');
    if (currentVideoElement?.length > 0) {
      if (!isMuted) {
        currentVideoElement[0].muted = false;
      } else {
        currentVideoElement[0].muted = true;
      }
      currentVideoElement[0].currentTime = 0;
      if (!previousVideoElement[0]?.paused) {
        currentVideoElement[0].play();
      }
    }
    if (previousVideoElement?.length > 0) {
      previousVideoElement[0].pause();
    }
  };

  const onVideoComplete = () => {
    if (layout?.videoSettings?.videoAutoPlay) {
      if (albumData?.length - 1 == index) {
        setIndex(0);
      } else {
        setIndex(index + 1);
      }
    }
  };

  const handleSharePopup = () => {
    setShowSharePopup((prevState) => !prevState);
  };

  const swiperRef = React.useRef(null);

  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };

  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };

  const { width } = UseWindowDimensions();
  return (
    <AnimatedModal isOpen={isOpen}>
      <style>{`${layout.gallerySettings.customCSS}`}</style>
      <idk-div class="zid-flex" style={{ flexDirection: 'row', cursor: 'pointer' }}>
        <idk-div
          class="zid-hidden md:zid-flex zid-items-center zid-justify-center zid-text-[30px] zid-text-[#fff] zid-bg-transparent"
          onClick={() => {
            if (index == 0) setIndex(albumData.length - 1);
            else setIndex(index - 1);
          }}
        >
          <MdArrowBackIos />
        </idk-div>
        <idk-div
          class="zid-justify-center zid-items-center zid-flex zid-inset-0"
          style={{
            width: width <= 576 ? '100%' : 'max-content',
            height: width <= 576 ? '100%' : '90vh',
          }}
        >
          {width < 600 && index !== null ? (
            <idk-div
              class="short_video_container zid-w-[100vw]"
              style={{ height: window?.visualViewport?.height || '100vh' }}
            >
              <style>{`.swiper-wrapper{ height: 100%!important}`}</style>
              <Swiper
                autoHeight
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                direction="vertical"
                slidesPerView={1}
                initialSlide={index}
                onInit={updateHeight}
                onSlideChange={(slider) => {
                  updateHeight();
                  setIndex(slider.activeIndex);
                  handleSlide(slider);
                  if (slider.isEnd) {
                    fetchNextPost();
                  }
                }}
                modules={[Navigation, Virtual]}
                navigation={{
                  nextEl: '.image-swiper-button-next',
                  prevEl: '.image-swiper-button-prev',
                  disabledClass: 'swiper-button-disabled',
                }}
                virtual={{
                  enabled: true,
                  addSlidesAfter: 1,
                  addSlidesBefore: 1,
                }}
              >
                {albumData.map((mediaData: any, index: number) => {
                  return (
                    <SwiperSlide id={`slide_${index}`} key={index} className="zid-h-full">
                      <idk-div class="zid-bg-white zid-w-full zid-h-full zid-rounded">
                        <idk-div class="zid-flex zid-flex-col sm:zid-flex-row zid-h-full zid-relative zid-border-2 zid-rounded">
                          <idk-div
                            class="zid-flex zid-w-full zid-h-full zid-bg-white"
                            style={{ flexDirection: width <= 600 ? 'column' : 'row' }}
                          >
                            <idk-div class="lg:zid-hidden zid-items-center zid-gap-2 zid-p-3 zid-border-b zid-border-b-slate-200 zid-hidden zid-md-flex">
                              <idk-div
                                class={`zid-h-8 zid-w-8 zid-bg-slate-300 zid-rounded-full zid-flex zid-items-center zid-justify-center zid-text-white ${
                                  albumData[index]?.profilePic != '0' &&
                                  albumData[index]?.profilePic != undefined &&
                                  albumData[index]?.username != '0' &&
                                  albumData[index]?.username != undefined
                                    ? ''
                                    : 'zid-invisible'
                                }`}
                              >
                                {albumData[index]?.profilePic ? (
                                  <img
                                    src={albumData[index]?.profilePic}
                                    className="zid-h-full zid-w-full zid-rounded-full"
                                    loading="lazy"
                                  ></img>
                                ) : (
                                  albumData[index]?.username?.charAt(0)?.toUpperCase()
                                )}
                              </idk-div>
                              {albumData[index]?.username != '0' && (
                                <idk-div class="zid-text-black">{albumData[index]?.username}</idk-div>
                              )}
                            </idk-div>
                            <idk-div
                              class="zid-relative zid-h-full"
                              style={{ maxWidth: width <= 600 ? '100%' : '50%' }}
                            >
                              {mediaData.media_type == 'VIDEO' && (
                                <idk-div
                                  class="zid-bg-[#0000004d] zid-rounded zid-flex zid-items-center zid-justify-center zid-h-[35px] zid-w-[35px]"
                                  style={{ position: 'absolute', top: '15px', left: '10px', zIndex: 99999999 }}
                                  onClick={() => toggleMute(index)}
                                >
                                  {isMuted ? (
                                    <GoMute fontSize="18px" color="#ffffff" />
                                  ) : (
                                    <GoUnmute fontSize="18px" color="#ffffff" />
                                  )}
                                </idk-div>
                              )}
                              <HotspotMedia
                                layout={layout}
                                isSwiper={true}
                                onVideoComplete={onVideoComplete}
                                autoPlay={layout?.popupSettings?.popupVideoAutoPlay}
                                isMuted={layout?.popupSettings?.popupVideoMute}
                                playFunctionality={true}
                                row={albumData[index]}
                                isModal={true}
                                style={{
                                  height: '100%',
                                  width: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                              <idk-div
                                class="zid-bg-[#0000004d] zid-rounded zid-flex zid-items-center zid-justify-center zid-h-[35px] zid-w-[35px]"
                                style={{ position: 'absolute', top: '15px', right: '10px', zIndex: 9999999 }}
                                onClick={() => onClose()}
                              >
                                <MdOutlineClose fontSize={18} color="#ffffff" />
                              </idk-div>
                              {layout?.popupSettings?.showShareBtn && (
                                <SharePopUp
                                  handleSharePopup={handleSharePopup}
                                  showSharePopup={showSharePopup}
                                  data={albumData[index]}
                                  isShopify={isShopify}
                                />
                              )}

                              {((width <= 600 && layout.gallerySettings.showProducts) ||
                                layout?.popupSettings?.showPostDescription == false) && (
                                <ProductsOverlay
                                  isOpen={isOpen}
                                  shopifyData={shopifyData}
                                  row={albumData[index]}
                                ></ProductsOverlay>
                              )}
                              {isFlag && (
                                <idk-div
                                  class="zid-absolute zid-bottom-4 zid-right-4 zid-p-1 zid-cursor-pointer zid-bg-gray-200 zid-rounded-md"
                                  style={{ border: '1px solid #1C2833' }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    setReportModalData(albumData[index]);
                                    onReportModalOpen();
                                  }}
                                >
                                  <FlagIcon width="20px" height="20px" fill="#1C2833" />
                                </idk-div>
                              )}
                            </idk-div>
                            {(layout?.popupSettings?.showPostDescription ||
                              layout?.popupSettings?.showPostDescription == undefined) &&
                              (isShopify &&
                              layout?.gallerySettings?.showModalProducts &&
                              albumData[index]?.products?.length > 0 ? (
                                <idk-div
                                  class="zid-hidden md:zid-flex zid-flex-col zid-justify-between"
                                  style={{ width: '350px' }}
                                >
                                  <ShopifyModalRight
                                    quantity={quantity}
                                    updateQuantity={setQuantity}
                                    row={albumData[index]}
                                    shopifyData={shopifyData}
                                  />
                                </idk-div>
                              ) : isWooCommerceSite() &&
                                layout?.gallerySettings?.showModalProducts &&
                                albumData[index]?.products?.length > 0 ? (
                                <idk-div
                                  class="zid-hidden md:zid-flex zid-flex-col zid-justify-between"
                                  style={{ width: '350px' }}
                                >
                                  <WocommerceModalRight
                                    quantity={quantity}
                                    updateQuantity={setQuantity}
                                    row={albumData[index]}
                                  />
                                </idk-div>
                              ) : (
                                <idk-div class="zid-flex zid-flex-col zid-justify-between" style={{ width: '350px' }}>
                                  <idk-div>
                                    <idk-div
                                      class={`zid-hidden lg:zid-flex zid-items-center zid-gap-2 zid-p-4 zid-border-b zid-border-b-slate-200`}
                                    >
                                      <idk-div
                                        class={`zid-h-8 zid-w-8 zid-bg-slate-300 zid-rounded-full zid-flex zid-items-center zid-justify-center zid-text-white ${
                                          albumData[index]?.profilePic != '0' &&
                                          albumData[index]?.profilePic != undefined &&
                                          albumData[index]?.username != '0' &&
                                          albumData[index]?.username != undefined
                                            ? ''
                                            : 'zid-invisible'
                                        }`}
                                      >
                                        {albumData[index]?.profilePic ? (
                                          <img
                                            src={albumData[index]?.profilePic}
                                            className="zid-h-full zid-w-full zid-rounded-full"
                                            loading="lazy"
                                          ></img>
                                        ) : (
                                          albumData[index]?.username?.charAt(0)?.toUpperCase()
                                        )}
                                      </idk-div>
                                      {albumData[index]?.username != '0' && (
                                        <idk-div class="zid-text-black">{albumData[index]?.username}</idk-div>
                                      )}
                                    </idk-div>
                                    <idk-div
                                      class="zid-p-3 lg:zid-p-4 zid-text-slate-600 zid-hidden md:zid-block"
                                      style={{ height: 'calc(90vh - 153px)', overflow: 'auto' }}
                                    >
                                      <idk-div class="zid-text-sm">
                                        {layout?.gallerySettings?.showPostCaption == false ? (
                                          <></>
                                        ) : (
                                          <ReadMoreReadLess totalWords={30}>
                                            {albumData[index]?.caption}
                                          </ReadMoreReadLess>
                                        )}
                                      </idk-div>
                                      {!isHotspot &&
                                        products &&
                                        layout?.gallerySettings?.showModalProducts &&
                                        products?.length > 0 && (
                                          <idk-div class="zid-w-[100%] zid-overflow-auto">
                                            <ModalHeader
                                              modalData={albumData[index]}
                                              closeModal={onClose}
                                              show={!isHotspot}
                                              isWooCommerceSite={isWooCommerceSite}
                                              currency={data.result.currency}
                                              shopifyData={shopifyData}
                                              layout={layout}
                                              clickMutate={clickMutate}
                                            />
                                          </idk-div>
                                        )}
                                    </idk-div>
                                  </idk-div>
                                  <idk-div class="zid-hidden md:zid-flex zid-items-center zid-justify-between zid-border-t zid-border-t-slate-200 zid-p-3 lg:zid-p-4">
                                    <idk-div>
                                      <idk-div class="zid-flex zid-mb-2 zid-gap-4">
                                        {albumData[index]?.like_count && albumData[index]?.like_count != 0 ? (
                                          <idk-div class="zid-flex zid-gap-1 zid-items-center">
                                            <img
                                              src="https://assets.idukki.io/widget-assets/HeartOutlineFill.svg"
                                              loading="lazy"
                                              height="20px"
                                              width="20px"
                                            />
                                            <idk-div>{albumData[index]?.like_count}</idk-div>
                                          </idk-div>
                                        ) : (
                                          ''
                                        )}
                                        {albumData[index]?.comments_count && albumData[index]?.comments_count != 0 ? (
                                          <idk-div class="zid-flex zid-gap-1 zid-items-center">
                                            <img
                                              src="https://assets.idukki.io/widget-assets/CommentOutline.svg"
                                              loading="lazy"
                                              height="20px"
                                              width="20px"
                                            />
                                            <idk-div>{albumData[index]?.comments_count}</idk-div>
                                          </idk-div>
                                        ) : (
                                          ''
                                        )}
                                      </idk-div>
                                      <idk-p class="zid-text-slate-600 zid-text-sm">
                                        {(layout?.popupSettings?.showPopupTimeline ||
                                          layout?.popupSettings?.showPopupTimeline == undefined) &&
                                          (window as any).moment &&
                                          albumData[index]?.timestamp &&
                                          (window as any).moment(albumData[index]?.timestamp).fromNow()}
                                      </idk-p>
                                    </idk-div>
                                    <idk-div class="zid-flex zid-flex-col zid-items-end">
                                      <idk-div class="zid-text-sky-800 hover:zid-underline zid-flex zid-gap-2">
                                        {albumData[index]?.source == 'Youtube' && (
                                          <img
                                            height={25}
                                            width={25}
                                            src="https://assets.idukki.io/widget-assets/YoutubeLogo.svg"
                                            loading="lazy"
                                          ></img>
                                        )}
                                        {albumData[index]?.source == 'Shorts' && (
                                          <img
                                            height={25}
                                            width={25}
                                            src="https://assets.idukki.io/widget-assets/ShortsLogo.svg"
                                            loading="lazy"
                                          ></img>
                                        )}
                                        {albumData[index]?.source == 'Instagram_business' && (
                                          <img
                                            height={25}
                                            width={25}
                                            src="https://assets.idukki.io/widget-assets/InstagramLogo.svg"
                                            loading="lazy"
                                          ></img>
                                        )}
                                        {albumData[index]?.source == 'Twitter' && (
                                          <img
                                            height={25}
                                            width={25}
                                            src="https://assets.idukki.io/widget-assets/XTwitterLogo.svg"
                                            loading="lazy"
                                          ></img>
                                        )}

                                        {albumData[index]?.permalink && (
                                          <a href={albumData[index]?.permalink} target="_blank">
                                            View Post
                                          </a>
                                        )}
                                      </idk-div>
                                      {(layout?.popupSettings?.showPoweredBy ||
                                        layout?.popupSettings?.showPoweredBy == undefined) && (
                                        <PoweredBy onPost={true} guid={guid} className="zid-p-0 zid-mr-0" />
                                      )}
                                    </idk-div>
                                  </idk-div>
                                </idk-div>
                              ))}
                          </idk-div>
                        </idk-div>
                      </idk-div>
                      <idk-div
                        class="zid-absolute zid-z-[100] zid-flex zid-gap-3 zid-flex-col zid-right-[10px]"
                        style={{ top: '50%', transform: 'translateY(-50%)' }}
                      >
                        <idk-div
                          onClick={handlePrev}
                          style={{ backdropFilter: 'blur(10px)' }}
                          class="image-swiper-button-prev zid-cursor-pointer zid-bg-[#090a0b33] zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
                        >
                          <MdKeyboardArrowUp color="#fff" fontSize={30} />
                        </idk-div>
                        <idk-div
                          onClick={handleNext}
                          style={{ backdropFilter: 'blur(10px)' }}
                          class="image-swiper-button-next zid-cursor-pointer zid-bg-[#090a0b33] zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
                        >
                          <MdKeyboardArrowDown color="#fff" fontSize={30} />
                        </idk-div>
                      </idk-div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </idk-div>
          ) : (
            <idk-div class="zid-bg-white zid-w-full zid-h-full zid-rounded" style={{ maxHeight: '100vh' }}>
              <idk-div class="zid-flex zid-flex-col sm:zid-flex-row zid-h-full zid-relative zid-border-2 zid-rounded">
                {layout?.popupSettings?.showPostDescription == false && (
                  <>
                    <idk-div
                      class="zid-bg-[#0000004d] zid-rounded zid-flex zid-items-center zid-justify-center zid-h-[35px] zid-w-[35px] zid-z-[99] zid-absolute zid-cursor-pointer"
                      style={{ right: '10px', top: '15px' }}
                    >
                      <MdOutlineClose fontSize={20} color="#fff" onClick={() => onClose()} />
                    </idk-div>
                    {layout?.popupSettings?.showShareBtn && (
                      <SharePopUp
                        handleSharePopup={handleSharePopup}
                        showSharePopup={showSharePopup}
                        data={albumData[index]}
                        isShopify={isShopify}
                      />
                    )}
                  </>
                )}

                <idk-div
                  class="zid-flex zid-w-full zid-h-full zid-bg-white"
                  style={{ flexDirection: width <= 600 ? 'column' : 'row' }}
                >
                  <idk-div class="lg:zid-hidden zid-items-center zid-gap-2 zid-p-3 zid-border-b zid-border-b-slate-200 zid-hidden zid-md-flex">
                    <idk-div
                      class={`zid-h-8 zid-w-8 zid-bg-slate-300 zid-rounded-full zid-flex zid-items-center zid-justify-center zid-text-white ${
                        albumData[index]?.profilePic != '0' &&
                        albumData[index]?.profilePic != undefined &&
                        albumData[index]?.username != '0' &&
                        albumData[index]?.username != undefined
                          ? ''
                          : 'zid-invisible'
                      }`}
                    >
                      {albumData[index]?.profilePic ? (
                        <img
                          src={albumData[index]?.profilePic}
                          className="zid-h-full zid-w-full zid-rounded-full"
                          loading="lazy"
                        ></img>
                      ) : (
                        albumData[index]?.username?.charAt(0)?.toUpperCase()
                      )}
                    </idk-div>
                    {albumData[index]?.username != '0' && (
                      <idk-div class="zid-text-black">{albumData[index]?.username}</idk-div>
                    )}
                  </idk-div>
                  <idk-div class="zid-relative zid-h-full">
                    <HotspotMedia
                      layout={layout}
                      autoPlay={layout?.popupSettings?.popupVideoAutoPlay}
                      isMuted={layout?.popupSettings?.popupVideoMute}
                      onVideoComplete={onVideoComplete}
                      showMute={true}
                      playFunctionality={true}
                      row={albumData[index]}
                      isModal={true}
                      style={{
                        height: '100%',
                        width: '100%',
                        objectFit: 'cover',
                      }}
                    />
                    <idk-div
                      class="zid-bg-[#0000004d] zid-rounded zid-flex md:zid-hidden zid-items-center zid-justify-center zid-h-[30px] zid-w-[30px]"
                      style={{ position: 'absolute', top: '15px', right: '10px' }}
                      onClick={() => onClose()}
                    >
                      <MdOutlineClose fontSize={18} color="#ffffff" />
                    </idk-div>

                    {((width <= 600 && layout.gallerySettings.showProducts) ||
                      layout?.popupSettings?.showPostDescription == false) && (
                      <ProductsOverlay
                        isOpen={isOpen}
                        shopifyData={shopifyData}
                        row={albumData[index]}
                      ></ProductsOverlay>
                    )}
                    {isFlag && (
                      <idk-div
                        class="zid-absolute zid-bottom-4 zid-right-4 zid-p-1 zid-cursor-pointer zid-bg-gray-200 zid-rounded-md"
                        style={{ border: '1px solid #1C2833' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          setReportModalData(albumData[index]);
                          onReportModalOpen();
                        }}
                      >
                        <FlagIcon width="20px" height="20px" fill="#1C2833" />
                      </idk-div>
                    )}
                  </idk-div>
                  {(layout?.popupSettings?.showPostDescription ||
                    layout?.popupSettings?.showPostDescription == undefined) &&
                    (isShopify &&
                    layout?.gallerySettings?.showModalProducts &&
                    albumData[index]?.products?.length > 0 ? (
                      <idk-div
                        class="zid-hidden md:zid-flex zid-flex-col zid-justify-between"
                        style={{ width: '350px' }}
                      >
                        <ShopifyModalRight
                          quantity={quantity}
                          updateQuantity={setQuantity}
                          row={albumData[index]}
                          shopifyData={shopifyData}
                        />
                      </idk-div>
                    ) : isWooCommerceSite() && albumData[index]?.products?.length > 0 ? (
                      <idk-div
                        class="zid-hidden md:zid-flex zid-flex-col zid-justify-between"
                        style={{ width: '350px' }}
                      >
                        <WocommerceModalRight quantity={quantity} updateQuantity={setQuantity} row={albumData[index]} />
                      </idk-div>
                    ) : (
                      <idk-div class="zid-flex zid-flex-col zid-justify-between" style={{ width: '350px' }}>
                        <idk-div>
                          <idk-div
                            class={`zid-hidden lg:zid-flex zid-items-center zid-gap-2 zid-p-4 zid-border-b zid-border-b-slate-200`}
                          >
                            <idk-div
                              class={`zid-h-8 zid-w-8 zid-bg-slate-300 zid-rounded-full zid-flex zid-items-center zid-justify-center zid-text-white ${
                                albumData[index]?.profilePic != '0' &&
                                albumData[index]?.profilePic != undefined &&
                                albumData[index]?.username != '0' &&
                                albumData[index]?.username != undefined
                                  ? ''
                                  : 'zid-invisible'
                              }`}
                            >
                              {albumData[index]?.profilePic ? (
                                <img
                                  src={albumData[index]?.profilePic}
                                  className="zid-h-full zid-w-full zid-rounded-full"
                                  loading="lazy"
                                ></img>
                              ) : (
                                albumData[index]?.username?.charAt(0)?.toUpperCase()
                              )}
                            </idk-div>
                            {albumData[index]?.username != '0' && (
                              <idk-div class="zid-text-black">{albumData[index]?.username}</idk-div>
                            )}
                          </idk-div>
                          <idk-div
                            class="zid-p-3 lg:zid-p-4 zid-text-slate-600 zid-hidden md:zid-block"
                            style={{ height: 'calc(90vh - 153px)', overflow: 'auto' }}
                          >
                            <idk-div class="zid-text-sm">
                              {layout?.gallerySettings?.showPostCaption == false ? (
                                <></>
                              ) : (
                                <ReadMoreReadLess totalWords={30}>{albumData[index]?.caption}</ReadMoreReadLess>
                              )}
                            </idk-div>
                            {!isHotspot &&
                            products &&
                            layout?.gallerySettings?.showModalProducts &&
                            products?.length > 0 ? (
                              <idk-div class="zid-w-[100%] zid-overflow-auto">
                                <ModalHeader
                                  modalData={albumData[index]}
                                  closeModal={onClose}
                                  show={!isHotspot}
                                  currency={data?.result?.currency}
                                  isWooCommerceSite={isWooCommerceSite}
                                  shopifyData={shopifyData}
                                  layout={layout}
                                  clickMutate={clickMutate}
                                />
                              </idk-div>
                            ) : (
                              <idk-div
                                class="zid-w-full zid-flex zid-justify-end zid-absolute"
                                style={{ top: '1%', right: '1%' }}
                              >
                                <idk-div
                                  class="zid-cursor-pointer zid-fixed zid-p-1 zid-bg-white zid-rounded-md"
                                  onClick={() => onClose()}
                                >
                                  <CloseIcon />
                                </idk-div>
                              </idk-div>
                            )}
                          </idk-div>
                        </idk-div>
                        <idk-div class="zid-hidden md:zid-flex zid-items-center zid-justify-between zid-border-t zid-border-t-slate-200 zid-p-3 lg:zid-p-4">
                          <idk-div>
                            <idk-div class="zid-flex zid-mb-2 zid-gap-4">
                              {albumData[index]?.like_count && albumData[index]?.like_count != 0 ? (
                                <idk-div class="zid-flex zid-gap-1 zid-items-center">
                                  <img
                                    src="https://assets.idukki.io/widget-assets/HeartOutlineFill.svg"
                                    loading="lazy"
                                    height="20px"
                                    width="20px"
                                  />
                                  <idk-div>{albumData[index]?.like_count}</idk-div>
                                </idk-div>
                              ) : (
                                ''
                              )}
                              {albumData[index]?.comments_count && albumData[index]?.comments_count != 0 ? (
                                <idk-div class="zid-flex zid-gap-1 zid-items-center">
                                  <img
                                    src="https://assets.idukki.io/widget-assets/CommentOutline.svg"
                                    loading="lazy"
                                    height="20px"
                                    width="20px"
                                  />
                                  <idk-div>{albumData[index]?.comments_count}</idk-div>
                                </idk-div>
                              ) : (
                                ''
                              )}
                            </idk-div>
                            <idk-p class="zid-text-slate-600 zid-text-sm">
                              {(layout?.popupSettings?.showPopupTimeline ||
                                layout?.popupSettings?.showPopupTimeline == undefined) &&
                                (window as any).moment &&
                                albumData[index]?.timestamp &&
                                (window as any).moment(albumData[index]?.timestamp).fromNow()}
                            </idk-p>
                          </idk-div>
                          <idk-div class="zid-flex zid-flex-col zid-items-end">
                            <idk-div class="zid-text-sky-800 hover:zid-underline zid-flex zid-gap-2">
                              {albumData[index]?.source == 'Youtube' && (
                                <img
                                  height={25}
                                  width={25}
                                  src="https://assets.idukki.io/widget-assets/YoutubeLogo.svg"
                                  loading="lazy"
                                ></img>
                              )}
                              {albumData[index]?.source == 'Shorts' && (
                                <img
                                  height={25}
                                  width={25}
                                  src="https://assets.idukki.io/widget-assets/ShortsLogo.svg"
                                  loading="lazy"
                                ></img>
                              )}
                              {albumData[index]?.source == 'Instagram_business' && (
                                <img
                                  height={25}
                                  width={25}
                                  src="https://assets.idukki.io/widget-assets/InstagramLogo.svg"
                                  loading="lazy"
                                ></img>
                              )}
                              {albumData[index]?.source == 'Twitter' && (
                                <img
                                  height={25}
                                  width={25}
                                  src="https://assets.idukki.io/widget-assets/XTwitterLogo.svg"
                                  loading="lazy"
                                ></img>
                              )}

                              {albumData[index]?.permalink && (
                                <a href={albumData[index]?.permalink} target="_blank">
                                  View Post
                                </a>
                              )}
                            </idk-div>
                            {(layout?.popupSettings?.showPoweredBy ||
                              layout?.popupSettings?.showPoweredBy == undefined) && (
                              <PoweredBy onPost={true} guid={guid} className="zid-p-0 zid-mr-0" />
                            )}
                          </idk-div>
                        </idk-div>
                      </idk-div>
                    ))}
                </idk-div>
              </idk-div>
            </idk-div>
          )}
        </idk-div>
        <idk-div
          class="zid-hidden md:zid-flex zid-items-center zid-text-[30px] zid-text-[#fff] zid-bg-transparent zid-min-w-[25px]"
          style={{ flexDirection: 'row', cursor: 'pointer' }}
          onClick={() => {
            if (index == albumData.length - 1) setIndex(0);
            else setIndex(index + 1);
          }}
        >
          <MdArrowForwardIos />
        </idk-div>
      </idk-div>
    </AnimatedModal>
  );
};

const SharePopUp = (props) => {
  const [copySuccess, setCopySuccess] = React.useState('');

  const { showSharePopup, handleSharePopup, data, isShopify } = props;
  const copyToClipboard = (link: string) => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        setCopySuccess('Link copied to clipboard!');
        setTimeout(() => {
          setCopySuccess('');
        }, 2000);
      })
      .catch((err) => {
        console.error('Failed to copy link: ', err);
      });
  };

  const shareUrl = isShopify
    ? `https://${window.location.host}/products/${data?.products?.[0]?.handle}`
    : data.products[0].product_url;
  const message = `Hello, check this out: ${shareUrl}`;

  const handleWhatsAppShare = () => {
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  const handleTwitterShare = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`;
    window.open(twitterUrl, '_blank', 'noopener,noreferrer');
  };
  return (
    <>
      <idk-div
        class="zid-bg-[#0000004d] zid-rounded zid-flex zid-items-center zid-justify-center zid-h-[35px] zid-w-[35px]"
        style={{
          position: 'absolute',
          top: '70%',
          right: '10px',
          zIndex: 9999999,
        }}
        onClick={() => handleSharePopup()}
      >
        <FaShare fontSize={18} color="#ffffff" />
      </idk-div>
      <idk-div
        class={`zid-h-36 zid-w-[75%] zid-bg-white zid-absolute zid-z-10 zid-rounded zid-transition-opacity zid-duration-500 zid-ease-in-out ${
          showSharePopup ? 'zid-opacity-100' : 'zid-opacity-0 zid-pointer-events-none'
        }`}
        style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
      >
        <idk-div class="zid-relative zid-flex zid-items-center zid-justify-center zid-h-full">
          <MdOutlineClose
            className="zid-absolute zid-right-4 zid-top-3"
            color="#000"
            fontSize={22}
            onClick={handleSharePopup}
          />
          <idk-div class="zid-flex zid-justify-around zid-w-full">
            <idk-div class="zid-flex zid-flex-col zid-items-center zid-font-semibold" onClick={handleWhatsAppShare}>
              <idk-div class="zid-h-12 zid-w-12 zid-flex zid-items-center zid-justify-center">
                <FaWhatsappSquare color="#24d366" fontSize={32} />
              </idk-div>
              Whatsapp
            </idk-div>
            <idk-div class="zid-flex zid-flex-col zid-items-center zid-font-semibold" onClick={handleTwitterShare}>
              <idk-div class="zid-h-12 zid-w-12 zid-flex zid-items-center zid-justify-center">
                <FaSquareXTwitter fontSize={32} />
              </idk-div>
              X
            </idk-div>
            <idk-div class="zid-flex zid-flex-col zid-items-center zid-font-semibold">
              <idk-div
                class="zid-h-12 zid-w-12 zid-flex zid-items-center zid-justify-center"
                onClick={() => copyToClipboard(shareUrl)}
              >
                <BsCopy fontSize={26} />
              </idk-div>
              {copySuccess ? 'Link copied!' : 'Copy link'}
            </idk-div>
          </idk-div>
        </idk-div>
      </idk-div>
    </>
  );
};
const ModalHeader = ({
  modalData,
  closeModal,
  show,
  currency,
  isWooCommerceSite,
  shopifyData,
  layout,
  clickMutate,
}) => {
  const ShopBtnComponent = ({ product }) => {
    const websiteArr = ['widget.idukki.io', 'widget-staging.idukki.io'];
    const btnRef = useRef();
    return (
      <>
        <style>{`
        .idk_shop_now_btn {
        ${layout?.productsSettings?.shopBtnCss}
        }
        `}</style>
        <idk-div
          ref={btnRef}
          onClick={() => {
            clickMutate(modalData.id, {
              event: 'add_to_cart',
              price: product?.variants?.[0]?.salePrice,
              productId: product?.id_from_product,
            });
            const shopBtnFunctionality = layout?.productsSettings?.shopBtnFunctionalityOverlay;
            if (shopBtnFunctionality) {
              try {
                const func = new Function('postData', 'productData', 'current', shopBtnFunctionality);
                func(modalData, product, btnRef);
              } catch (error) {
                console.error('Error executing shopBtnFunctionality', error);
              }
            } else {
              window.open(
                product?.product_url
                  ? `${product.product_url}?utm_source=${
                      layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                    }&utm_medium=${layout?.gallerySettings?.utmMedium || 'AddToCart'}&utm_campaign=${
                      layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                    }`
                  : !websiteArr.includes(window.location.hostname)
                  ? `https://${window.location.hostname}`
                  : 'https://app.idukki.io/register',
                '_blank',
              );
            }
          }}
          class="zid-w-max zid-rounded-md zid-bg-blue-600 zid-px-4 zid-py-1 zid-text-[12px] zid-text-white zid-cursor-pointer zid-min-w-[100px] idk_shop_now_btn"
          dangerouslySetInnerHTML={{ __html: layout?.productsSettings?.shopBtnText || 'Add to cart' }}
        ></idk-div>
      </>
    );
  };

  return (
    <>
      <style>
        {` 
      .idk_btn_price_container{
        ${layout?.productsSettings?.priceBtnContainerCss}}`}
      </style>
      <idk-div class="zid-flex zid-flex-col zid-justify-between zid-overflow-x-hidden zid-overflow-auto zid-w-full">
        <idk-div class="zid-flex zid-flex-col">
          <idk-div class="zid-w-full zid-flex zid-justify-end zid-absolute" style={{ top: '1%', right: '1%' }}>
            <idk-div
              class="zid-cursor-pointer zid-fixed zid-p-1 zid-bg-white zid-rounded-md"
              onClick={() => closeModal()}
            >
              <CloseIcon />
            </idk-div>
          </idk-div>
          {show && (
            <idk-div class="zid-flex zid-flex-col zid-text-gray-700 zid-text-[18px] zid-gap-4 zid-h-full">
              <idk-div class="zid-flex zid-justify-between zid-pr-[50px]">
                <idk-div class="zid-flex zid-gap-2">
                  {modalData?.logo && (
                    <idk-div class="zid-border-2 zid-border-solid zid-h-[40px] zid-w-[40px] zid-overflow-hidden zid-rounded-[999px]">
                      <img src={modalData?.logo} className="zid-w-full" loading="lazy" />
                    </idk-div>
                  )}
                  {modalData?.product_name && (
                    <idk-div class="zid-flex zid-gap-[1px] zid-flex-col zid-text-[14px] zid-leading-[14px] zid-justify-center">
                      <idk-p>{modalData?.product_name}</idk-p>
                    </idk-div>
                  )}
                </idk-div>
              </idk-div>

              <idk-div class="zid-flex zid-flex-wrap zid-w-full zid-flex-col zid-text-[12px] zid-break-words">
                {modalData?.description && <idk-p class="zid-mb-4">{modalData?.description}</idk-p>}
                <idk-div class="zid-flex zid-flex-col zid-w-full zid-gap-6">
                  <>
                    {modalData?.products?.map((product, id1) => {
                      return (
                        <idk-div key={id1} class="zid-flex zid-w-full zid-justify-between zid-gap-2">
                          {product?.images && (
                            <idk-div
                              class=" zid-rounded zid-flex zid-items-center zid-white"
                              style={{ width: '80px', height: '80px', overflow: 'hidden', flex: '0 0 80px' }}
                            >
                              <img
                                onClick={() => {
                                  window.open(
                                    shopifyData
                                      ? `https://${window.location.host}/products/${product?.handle}`
                                      : `${product?.product_url}?utm_source=${
                                          layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                        }&utm_medium=${
                                          layout?.gallerySettings?.utmMedium || 'AddToCart'
                                        }&utm_campaign=${
                                          layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                        }`,
                                    '_blank',
                                  );
                                }}
                                src={product?.images[0]?.image_url.replaceAll('resize/800x800', 'resize/64x64')}
                                className="zid-w-full zid-h-full zid-object-contain"
                                loading="lazy"
                              />
                            </idk-div>
                          )}
                          <idk-div
                            class="zid-flex zid-gap-[10px] zid-text-[12px] zid-flex-col zid-overflow-hidden"
                            style={{ flexGrow: 1 }}
                          >
                            <idk-p
                              onClick={() => {
                                window.open(
                                  shopifyData
                                    ? `https://${window.location.host}/products/${product?.handle}`
                                    : `${product?.product_url}?utm_source=${
                                        layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                      }&utm_medium=${layout?.gallerySettings?.utmMedium || 'AddToCart'}&utm_campaign=${
                                        layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                      }`,
                                  '_blank',
                                );
                              }}
                              class="zid-font-bold zid-text-base"
                              style={{ fontSize: '14px' }}
                            >
                              {product?.title}
                            </idk-p>
                            {product?.description &&
                              product?.description?.trim() &&
                              layout?.productsSettings?.showProductDescription && (
                                <idk-p dangerouslySetInnerHTML={{ __html: product?.description }}></idk-p>
                              )}
                            <idk-div class="idk_btn_price_container">
                              {product?.variants && (
                                <idk-p
                                  class="zid-mt-1 zid-p-0 zid-mb-0 zid-font-bold"
                                  style={{ fontSize: '14px', minWidth: '100px' }}
                                >
                                  {isWooCommerceSite() &&
                                    !currency &&
                                    document?.getElementsByClassName('woocommerce-Price-currencySymbol')?.[0]
                                      ?.innerHTML}
                                  {shopifyData?.currency?.active &&
                                    !currency &&
                                    getCurrentSymbol(shopifyData?.currency?.active, shopifyData?.locale)}
                                  <span className="zid-font-bold">
                                    <PriceDisplay
                                      price={product?.variants?.[0]?.price}
                                      salePrice={product?.variants?.[0]?.salePrice}
                                      currency={currency}
                                    />
                                  </span>
                                </idk-p>
                              )}
                              <idk-div class="zid-flex  zid-items-center zid-mt-1">
                                <ShopBtnComponent product={product} />
                              </idk-div>
                            </idk-div>
                          </idk-div>
                        </idk-div>
                      );
                    })}
                  </>
                </idk-div>
              </idk-div>
            </idk-div>
          )}
        </idk-div>
      </idk-div>
    </>
  );
};

export default Modal;
